const doc = [({"ja":({"adminConstantPromotionFixedDiscountApplyTargetType":({"total":"予約全体", "perAdultPerStay":"大人一人一泊あたり", "perAdultAndIncludedChildPerStay":"大人と大人料金計算時に含める子供一人一泊あたり"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;